import { Circle } from './styles'

const CircleSeparator = () => <Circle />

export default CircleSeparator
